import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modal", "body", "aiMessage"]

    connect() {
        this.handleEscape = this.handleEscape.bind(this)
        document.addEventListener('keydown', this.handleEscape)
    }

    disconnect() {
        document.removeEventListener('keydown', this.handleEscape)
    }

    // An Ask AI reply that flagged the question opens the modal prefilled with the
    // tutor's report (data-report-mistake-body-param) and tied to that reply
    // (data-report-mistake-ai-message-param), which comments#create links up.
    open(event) {
        if (this.hasModalTarget) {
            const params = event?.params || {}
            if (this.hasBodyTarget && params.body) this.bodyTarget.value = params.body
            if (this.hasAiMessageTarget) this.aiMessageTarget.value = params.aiMessage || ''
            this.modalTarget.classList.remove('hidden')
            document.body.classList.add('overflow-hidden')
            if (this.hasBodyTarget) {
                setTimeout(() => this.bodyTarget.focus(), 100)
            }
        }
    }

    close() {
        if (this.hasModalTarget) {
            this.modalTarget.classList.add('hidden')
            document.body.classList.remove('overflow-hidden')
            if (this.hasBodyTarget) {
                this.bodyTarget.value = ''
            }
            if (this.hasAiMessageTarget) {
                this.aiMessageTarget.value = ''
            }
        }
    }

    handleEscape(event) {
        if (event.key === 'Escape') {
            this.close()
        }
    }

    onSubmitEnd(event) {
        if (event.detail.success) {
            setTimeout(() => this.close(), 2000)
        }
    }
}
